import { useMemo } from 'react';

import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { Icon } from '@atom/mui';

import colors from '../../styles/colors';

import DrawerContentList from './drawerContent/ContentList';
import AssetsListWrapper from './drawerContentWrappers/AssetsListWrapper';
import AssetSummaryWrapper from './drawerContentWrappers/AssetSummaryWrapper';
import KmlPlacemarkWrapper from './drawerContentWrappers/KmlPlacemarkWrapper';
import MapDrawerLayersWrapper from './drawerContentWrappers/MapDrawerLayersWrapper';
import UserSummaryWrapper from './drawerContentWrappers/UserSummaryWrapper';
import WorkOrderGroupListWrapper from './drawerContentWrappers/WorkOrderGroupListWrapper';
import WorkSummaryWrapper from './drawerContentWrappers/WorkSummaryWrapper';

import classes from './mapDrawerContent.module.css';

const MapDrawerContent = () => {
  const [{ view, collapsed }, { updateSearchParams }] = useNavigation({
    view: SearchParamType.STRING,
    collapsed: SearchParamType.BOOLEAN,
  });

  const layerMap = {
    layers: MapDrawerLayersWrapper,
    workOrder: WorkSummaryWrapper,
    user: UserSummaryWrapper,
    asset: AssetSummaryWrapper,
    list: DrawerContentList,
    assets: AssetsListWrapper,
    workOrders: WorkOrderGroupListWrapper,
    kml: KmlPlacemarkWrapper,
  };

  const ActiveComponent: any = useMemo(() => layerMap[view] || 'div', [view]);

  return (
    <div className={classes.container}>
      <div className={classes.content}>{!collapsed && <ActiveComponent />}</div>
      <div
        className={classes.drawerArrow}
        onClick={() => {
          updateSearchParams({ collapsed: collapsed ? '' : true });
        }}
      >
        <Icon
          className={collapsed ? classes.collapsed : classes.expanded}
          color={colors.neutral.gray}
        >
          arrow_drop_down
        </Icon>
      </div>
    </div>
  );
};

export default MapDrawerContent;
